import { FONT_API } from '@constants/Defaults';
import { FontType } from '@packages/style/fonts';

/**
 * Generate google font's string
 * @param family
 * @param variations
 * @returns {string}
 */
export function generateGoogleFonts(family: string | FontType | FontType[], variations?: string[] | number[]): string {
    if (Array.isArray(family)) {
        family = family.map((font) => generateGoogleFonts(font)).join('|');
    } else if (typeof family === 'object') {
        variations = family.variations;
        family = family.font;
    }

    return `${family}${variations ? `:${variations.join(',')}` : ''}`;
}

/**
 * Generate google font url
 * @param family
 * @param variations
 * @returns {string}
 */
export function fontUrl(family: string | FontType | FontType[], variations?: string[] | number[]): string {
    let fonts = generateGoogleFonts(family, variations);

    fonts = fonts.replace(/\s\s/g, ' ').replace(/\s/g, '+').replace(/^:/g, '').replace(/:$/g, '').trim();

    return `${FONT_API}/css?family=${fonts}`;
}
